// src/api/config.js
// Configuracao centralizada de endpoints.
// Todos os aplicativos (site, desktop, mobile) apontam para este dominio unico.
// Para trocar uma Lambda, basta alterar o API Mapping na AWS — zero mudanca de codigo.

const BASE_URL = "https://api.delidapersy.com.br";

export const API = {
  LOGIN:       `${BASE_URL}/login`,
  MESAS:       `${BASE_URL}/mesas`,
  PEDIDOS:     `${BASE_URL}/pedidos`,
  CAIXA:       `${BASE_URL}/caixa`,
  ESTOQUE:     `${BASE_URL}/estoque`,
  PAGAMENTO:   `${BASE_URL}/pagamento`,
  PENDENCIAS:  `${BASE_URL}/pendencias`,
  PONTO:       `${BASE_URL}/ponto`,
  ASSINATURAS: `${BASE_URL}/assinaturas`,
  LUDOPEDIA:   `${BASE_URL}/ludopedia`,
  RESERVAS:    `${BASE_URL}/reservas`,
  WHATSAPP:    `${BASE_URL}/whatsapp`,
  INFINITYPAY: `${BASE_URL}/infinitypay`,
};
